import { render, staticRenderFns } from "./CaseRecordList.vue?vue&type=template&id=4efbb7ce&scoped=true"
import script from "./CaseRecordList.vue?vue&type=script&lang=js"
export * from "./CaseRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efbb7ce",
  null
  
)

export default component.exports